import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";

const fmt = (d) =>
  d && dayjs(d).isValid() ? dayjs(d).format("MM/DD/YYYY") : "";

// View vs edit (QA 2026-09-27, saved vitals looked blank on reopen): the
// cards start in VIEW mode when previousdata is a reading saved today for
// this card, and in EDIT mode for a first entry. created_at is the server's
// "YYYY-MM-DD HH:MM:SS" -- same same-day rule Intake.jsx uses for row_id.
const hasValue = (v) => v !== "" && v !== null && v !== undefined;
const isToday = (d) =>
  Boolean(d) && dayjs(d).isValid() && dayjs(d).isSame(dayjs(), "day");
// Other card's own values (glucose + vision).
const hasOtherReading = (pd) =>
  [pd?.bg, pd?.right_eye, pd?.left_eye].some(hasValue);

export const OtherModal = ({
  glucose,
  setGlucose,
  glucoseUnit,
  setGlucoseUnit,
  glucoseFasting,
  setGlucoseFasting,
 finalsave,
    finalload,
  vodR,
  setVodR,
  vodL,
  setVodL,
  vosL,
  setVosL,

  previousdata = {},
  handleSave,
}) => {
  const clearAllFields = () => {
  setGlucose("");
  setGlucoseUnit("mg/dl");
  setGlucoseFasting("Not-fasting");

  setVodR("");
  setVodL("");
  setVosL("");
};
// Unsaved input already in this card's fields: Intake keeps the form
// state across sub-tab switches (only this card remounts), so stay in
// edit instead of hiding it behind view.
const hasUnsaved = [glucose, vodR, vodL, vosL].some(hasValue);
// Edit for a first entry or unsaved input; view when today's reading is saved.
const [isGlobalEdit, setIsGlobalEdit] = useState(
  () =>
    hasUnsaved ||
    !(isToday(previousdata?.created_at) && hasOtherReading(previousdata))
);
const justSavedRef = useRef(false);
// Go to view when today's reading arrives (async fetch on open) or when
// the refetch after Save lands. Intake refetches previousdata only on a
// successful save, so a failed save stays in edit with the inputs kept.
// Never while the card holds unsaved input (mount after a sub-tab switch,
// or a refetch mid-entry); a successful save has already cleared it.
useEffect(() => {
  if (!previousdata?.created_at) return;
  if (
    hasOtherReading(previousdata) &&
    !hasUnsaved &&
    (justSavedRef.current || isToday(previousdata.created_at))
  ) {
    setIsGlobalEdit(false);
  }
  justSavedRef.current = false;
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [previousdata]);

  const hydrateFromPrevious = () => {
    setGlucose(previousdata?.bg || "");
    setGlucoseUnit(previousdata?.bg_cel || "mg/dl");
    setGlucoseFasting(previousdata?.bg_drop || "Not-fasting");

    setVodR(previousdata?.right_eye || "");
    setVodL(previousdata?.left_eye || "");
    setVosL(previousdata?.os_left_eye || "");
    setGlucose(previousdata?.bg || "");
    setGlucoseUnit(previousdata?.bg_cel || "");
    setGlucoseFasting(previousdata?.bg_drop || "");
    setVodR(previousdata?.right_eye || "");
    setVodL(previousdata?.left_eye || "");
  };

  return (
    <div className="bg-white p-6">
      <div className="flex items-center gap-2 justify-end mb-2">

  {/* + only in VIEW mode */}
  {!isGlobalEdit && (
    <div
      onClick={() => {
      clearAllFields()
        setIsGlobalEdit(true);
      }}
      className="h-8 w-8 cursor-pointer rounded-full bg-[#FDE2DA] text-[#E07A5F] text-xl flex items-center justify-center"
    >
      +
    </div>
  )}

  {/* Save only in EDIT mode */}
  {isGlobalEdit && (
    <button
      onClick={() => {
        justSavedRef.current = true; // view follows the post-save refetch
        finalsave();
      }}
      className="rounded-md bg-[#1D2951] px-6 py-1 text-sm font-semibold text-white"
      disabled={finalload}
    >
      Save
    </button>
  )}
</div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* ================= BLOOD GLUCOSE ================= */}
        <EditableCard
          title="Blood Glucose"
          hydrateFromPrevious={hydrateFromPrevious}
           clearAllFields={clearAllFields}
             isGlobalEdit={isGlobalEdit}
        >
          {({ isEditing, stopEdit }) =>
            !isEditing ? (
              <>
             <BigValue>
  {previousdata?.bg !== "" &&
  previousdata?.bg !== null &&
  previousdata?.bg !== undefined
    ? previousdata.bg
    : "--"}

  {previousdata?.bg !== "" &&
    previousdata?.bg !== null &&
    previousdata?.bg !== undefined && (
      <Unit>{previousdata?.bg_cel}</Unit>
    )}
</BigValue>


                <Meta text={fmt(previousdata?.created_at)} />
                <Tag text={previousdata?.bg_drop || ""} />
              </>
            ) : (
              <>
                <div className="flex flex-col justify-start items-start">
                  <Label>Reading</Label>

                  <Input value={glucose} onChange={setGlucose} />

                  {/* Glucose unit pill toggle */}
                  <div className="mt-3 inline-flex items-center gap-1 rounded-xl bg-slate-100 p-1">
                    {["mg/dl", "mmol/L"].map((u) => (
                      <UnitBtn
                        key={u}
                        active={glucoseUnit === u}
                        onClick={() => setGlucoseUnit(u)}
                      >
                        {u}
                      </UnitBtn>
                    ))}
                  </div>

                  {/* Fasting state pill toggle */}
                  <div className="mt-3 inline-flex items-center gap-1 rounded-xl bg-slate-100 p-1">
                    {["Not-fasting", "Fasting"].map((t) => (
                      <UnitBtn
                        key={t}
                        active={glucoseFasting === t}
                        onClick={() => setGlucoseFasting(t)}
                      >
                        {t}
                      </UnitBtn>
                    ))}
                  </div>
{/* 
                  <Actions
                    onSave={() => {
                      handleSave();
                      stopEdit();
                    }}
                  onCancel={() => {
  hydrateFromPrevious();
  stopEdit();
}}

                  /> */}
                </div>
              </>
            )
          }
        </EditableCard>

        {/* ================= VISION ================= */}
        <EditableCard title="Vision"   isGlobalEdit={isGlobalEdit} hydrateFromPrevious={hydrateFromPrevious}  clearAllFields={clearAllFields}>
          {({ isEditing, stopEdit }) =>
            !isEditing ? (
              <>
          <BigValue>
  {previousdata?.right_eye !== "" &&
  previousdata?.right_eye !== null &&
  previousdata?.right_eye !== undefined
    ? `20/${previousdata.right_eye}`
    : "-"}

  <span className="ml-2 text-sm text-slate-500">OD Right</span>
</BigValue>


                <div className="mt-2 text-[28px] font-bold text-[#1D2951]">
  {previousdata?.left_eye !== "" &&
  previousdata?.left_eye !== null &&
  previousdata?.left_eye !== undefined
    ? `20/${previousdata.left_eye}`
    : "-"}

  <span className="ml-2 text-sm text-slate-500">OD Left</span>
</div>


                {previousdata?.os_left_eye && (
                  <div className="mt-2 text-sm text-slate-600">
                    OS Left Eye: {previousdata.os_left_eye} cm
                  </div>
                )}

                <Meta text={fmt(previousdata?.created_at)} />
              </>
            ) : (
              <>
              <div className="flex flex-col justify-start items-start">
                <Label>V OD Right Eye</Label>
                <div className="flex items-center gap-2 w-full">
                  <div className="flex w-full overflow-hidden rounded border bg-white">
                    <span className="flex items-center bg-[#F3F4F6] px-3 text-sm text-slate-500">
                      20/
                    </span>
                    <input
                      value={vodR}
                      onChange={(e) => setVodR(e.target.value)}
                      className="h-10 w-full border-0 px-3 outline-none"
                    />
                  </div>
                </div>

                <Label className="mt-4">V OD Left Eye</Label>
                <div className="flex items-center gap-2 w-full">
                  <div className="flex w-full overflow-hidden rounded border bg-white">
                    <span className="flex items-center bg-[#F3F4F6] px-3 text-sm text-slate-500">
                      20/
                    </span>
                    <input
                      value={vodL}
                      onChange={(e) => setVodL(e.target.value)}
                      className="h-10 w-full border-0 px-3 outline-none"
                    />
                  </div>
                </div>

                <Label className="mt-4">V OS Left Eye</Label>
                <div className="flex items-center gap-3 w-full">
                  <div className="flex w-full overflow-hidden rounded border bg-white">
                    <input
                      value={vosL}
                      onChange={(e) => setVosL(e.target.value)}
                      className="h-10 w-full border-0 px-3 outline-none"
                    />
                    <span className="flex items-center bg-[#F3F4F6] px-3 text-sm text-slate-500">
                      cm
                    </span>
                  </div>
                </div>

                {/* <Actions
                  onSave={() => {
                    handleSave();
                    stopEdit();
                  }}
                 onCancel={() => {
  hydrateFromPrevious();
  stopEdit();
}}

                /> */}
                </div>
              </>
            )
          }
        </EditableCard>

      </div>
    </div>
  );
};

/* ================= REUSABLE UI ================= */

const EditableCard = ({ title, children, hydrateFromPrevious,clearAllFields , isGlobalEdit,}) => {
  const [isEditing, setIsEditing] = useState(isGlobalEdit);
  React.useEffect(() => {
    setIsEditing(isGlobalEdit);
  }, [isGlobalEdit]);
  return (
    <div className="relative rounded-xl border bg-[#F9FAFB] p-6">
      <div className="flex justify-between">
        <div className="font-medium text-[#1D2951]">{title}</div>
        {/* {!isEditing && (
          <button
            onClick={() => {
             clearAllFields();  
              setIsEditing(true);
            }}
            className="h-8 w-8 rounded-full bg-[#FDE2DA] text-[#E07A5F] text-xl"
          >
            +
          </button>
        )} */}
      </div>

      <div className="mt-4">
        {children({ isEditing, stopEdit: () => setIsEditing(false) })}
      </div>
    </div>
  );
};

const BigValue = ({ children }) => (
  <div className="text-[36px] font-bold text-[#1D2951]">{children}</div>
);

const Unit = ({ children }) => (
  <span className="ml-1 text-lg text-slate-500">{children}</span>
);

const Meta = ({ text }) => (
  <div className="mt-1 text-sm text-slate-400">{text}</div>
);

const Tag = ({ text }) => (
  <div className="mt-3 inline-block rounded bg-slate-100 px-3 py-1 text-sm text-slate-600">
    {text}
  </div>
);

const Label = ({ children, className = "" }) => (
  <div className={`mb-1 text-sm text-slate-600 ${className}`}>{children}</div>
);

const Input = ({ value, onChange }) => (
  <input
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="h-10 w-full rounded border px-3"
  />
);

const UnitBtn = ({ active, children, onClick }) => (
  <button
    onClick={onClick}
    className={`rounded-xl px-3 py-2 text-sm font-medium transition ${
      active
        ? "bg-white text-[#E07A5F] shadow-sm"
        : "bg-transparent text-slate-500 hover:text-slate-700"
    }`}
  >
    {children}
  </button>
);

const Actions = ({ onSave, onCancel }) => (
  <div className="mt-6 flex gap-4">
    <button
      onClick={onSave}
      className="rounded bg-[#E07A5F] px-6 py-2 text-white"
    >
      Save
    </button>
    <button onClick={onCancel} className="text-[#1D2951]">
      Cancel
    </button>
  </div>
);
